/* ============================================================
   fenou-abo.js
   Verhalten der Kaufoptionen und der Sticky-Leiste.

   Der Knopf der Sticky-Leiste legt selbst in den Warenkorb --
   ueber /cart/add.js, nicht ueber den Knopf des Themes. Grund:
   Der Knopf des Themes oeffnet danach die Warenkorb-Schublade,
   und genau das soll hier nicht passieren. Stattdessen geht es
   hinauf zur Auswahl.

   Was dabei erhalten bleibt: Der Lieferplan wandert als
   selling_plan mit, also bleibt Loop zustaendig. Und das Theme
   erfaehrt vom neuen Warenkorb ueber sein eigenes Ereignis
   cart:refresh -- die Zahl am Warenkorb-Symbol zaehlt hoch, die
   Schublade bleibt zu.
   ============================================================ */

(function () {
  'use strict';

  var VERSTECKT = 'is-hidden';
  var SCHWELLE = 30; /* wie beim Header in nav-v2.js */

  /* Ohne Leerzeichen vor dem Zeichen -- so setzt der money-Filter
     des Shops die Preise, und auf derselben Kachel duerfen nicht
     zwei Schreibweisen nebeneinander stehen. */
  function euro(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + '€';
  }

  function init(wurzel) {
    /* Schutz gegen doppelte Anmeldung: Seit der Quick Cart nachtraeglich
       initialisiert wird, kann init mehrfach auf dasselbe Element
       treffen. Ohne diese Marke haetten die Optionen dann zwei
       Klick-Behandlungen und wuerden zweimal in den Warenkorb legen. */
    if (wurzel.getAttribute('data-fenou-init') === '1') { return; }
    wurzel.setAttribute('data-fenou-init', '1');

    var formId = wurzel.getAttribute('data-form');
    var form = document.getElementById(formId) ||
               document.querySelector('form.shopify-product-form');
    if (!form) { return; }

    var opts = [].slice.call(wurzel.querySelectorAll('.fenou-abo__opt'));
    var bar = wurzel.querySelector('.fenou-abobar');
    if (!opts.length) { return; }

    /* ----------------------------------------------------------
       Formularfelder. name="id" liefert das Theme mit, es steht
       aber je nach Zustand als disabled im Markup -- deshalb beim
       Setzen immer freischalten. selling_plan legt das Skript bei
       Bedarf selbst an; Loop liest es beim Absenden aus.
       ---------------------------------------------------------- */
    function feld(name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        form.appendChild(el);
      }
      return el;
    }

    /* Vorgewaehlt ist, was Liquid markiert hat -- nicht stur die
       erste Zeile. Sonst gaebe es zwei Wahrheiten: die serverseitig
       gerenderte Markierung und die des Skripts. Faellt das Skript
       aus, gilt weiterhin die von Liquid. */
    var gewaehlt = wurzel.querySelector('.fenou-abo__opt.is-on') || opts[0];

    function uebernehmen() {
      var id = gewaehlt.getAttribute('data-variant');
      var plan = gewaehlt.getAttribute('data-plan');

      var fId = feld('id');
      fId.disabled = false;
      fId.value = id;

      var fPlan = form.querySelector('[name="selling_plan"]');
      if (plan) {
        if (!fPlan) { fPlan = feld('selling_plan'); }
        fPlan.disabled = false;
        fPlan.value = plan;
      } else if (fPlan) {
        /* Entfernen statt leeren: ein leeres selling_plan wuerde
           als Abo mit unbekanntem Plan gelesen werden. */
        fPlan.parentNode.removeChild(fPlan);
      }
    }

    function anzeigen() {
      opts.forEach(function (o) {
        var an = o === gewaehlt;
        o.classList.toggle('is-on', an);
        o.setAttribute('aria-checked', an ? 'true' : 'false');
      });

      if (bar) {
        var preis = parseInt(gewaehlt.getAttribute('data-preis'), 10) || 0;
        var nmEl = gewaehlt.querySelector('.fenou-abo__nm');
        var name = nmEl ? nmEl.childNodes[0].nodeValue.trim() : '';

        /* Der Produktname in der Leiste bleibt, wie er ist. Mit dem
           Umwaehlen aendern sich zwei Dinge: der Preis und die
           Beschriftung des Stufenwechslers. */
        var barPr = bar.querySelector('.fenou-abobar__pr');
        if (barPr) { barPr.textContent = euro(preis); }

        var barNm = bar.querySelector('.fenou-abobar__nm');
        if (barNm) { barNm.textContent = name; }

        /* Die eigene Produktseite von OVA GOLD schreibt den Preis in
           ihren Kaufknopf ("In den Warenkorb – 89,98 €"). Sie zieht
           ihn aus ihrer alten Auswahl, die hier ausgeblendet ist --
           also bliebe er stehen. Wenn es ihn gibt, wandert er mit. */
        var atc = document.querySelector('.fenou-atc-price');
        if (atc) { atc.textContent = '– ' + euro(preis); }

        spiegeln();
      }
    }

    /* ----------------------------------------------------------
       Preis im Kaufknopf des Themes.

       Der Knopf gehoert nicht diesem Baustein, sondern dem Theme
       (#AddToCart). Er traegt data-button-content -- daraus stellt
       theme.js die Beschriftung wieder her, nachdem es kurz
       "Hinzugefuegt" angezeigt hat. Deshalb wird beides gesetzt:
       sichtbarer Text und Attribut. Sonst waere der Preis nach dem
       ersten Klick wieder weg.

       Der Betrag wird nicht in JavaScript formatiert, sondern aus
       der gewaehlten Zeile abgelesen. Liquid hat ihn dort schon mit
       der richtigen Waehrung und Schreibweise ausgegeben -- eine
       eigene Formatierung waere eine zweite Wahrheit, die bei
       fenou.es oder einem Markt mit anderer Waehrung auseinanderfaellt.

       Die ursprungliche Beschriftung wird einmal gemerkt, damit aus
       "In den Warenkorb" nicht nach mehrfachem Umwaehlen
       "In den Warenkorb 60,00€ 80,00€" wird.
       ---------------------------------------------------------- */
    var kaufKnopf = form.querySelector('[data-product-add-to-cart-button]') ||
                    form.querySelector('.product-form__add-button');
    var kaufText = kaufKnopf
      ? (kaufKnopf.getAttribute('data-button-content') || kaufKnopf.textContent).trim()
      : '';

    /* Das ausgeblendete Loop-Widget schreibt bei jedem
       Variantenwechsel "In den Warenkorb" zurueck in den Knopf
       (loop_widget.js, updateButtonInnerHTMLLoopWidget) -- der Preis
       war dann nach einem Augenblick wieder weg. Der Beobachter setzt
       ihn danach wieder ein, aber nur wenn genau der nackte Text
       dasteht: Lade- oder "Hinzugefuegt"-Zustaende des Themes bleiben
       unberuehrt. */
    var kaufSoll = '';
    if (kaufKnopf && window.MutationObserver) {
      new MutationObserver(function () {
        if (kaufSoll && kaufSoll !== kaufText && kaufKnopf.textContent.trim() === kaufText) {
          kaufKnopf.textContent = kaufSoll;
        }
      }).observe(kaufKnopf, { childList: true, characterData: true, subtree: true });
    }

    function knopfBeschriften(o) {
      if (!kaufKnopf || !o) { return; }
      var zeile = o.querySelector('.fenou-abo__prline');
      if (!zeile) { return; }
      var spans = zeile.querySelectorAll('span');
      var betrag = spans.length ? spans[spans.length - 1].textContent.trim() : '';
      if (!betrag) { return; }
      var neu = kaufText + ' · ' + betrag;
      kaufSoll = neu;
      kaufKnopf.textContent = neu;
      kaufKnopf.setAttribute('data-button-content', neu);
    }

    function waehlen(o) {
      gewaehlt = o;
      uebernehmen();
      anzeigen();
      knopfBeschriften(o);
      kbZeigen(o);
    }

    /* ----------------------------------------------------------
       Neue Kaufbox (.fenou-kb): Umschalter Abo / Einmalkauf und die
       Infozeile unter den Kacheln. Ohne diese Markup-Teile tut der
       Block nichts -- die alte Fassung bleibt unberuehrt.

       Der Umschalter waehlt in der anderen Gruppe dieselbe
       Stueckzahl, damit nur die Kaufart wechselt, nicht die Menge.
       ---------------------------------------------------------- */
    var kb = wurzel.classList.contains('fenou-kb');

    function kbModus(o) {
      var g = o && o.closest('[data-gruppe]');
      return g ? g.getAttribute('data-gruppe') : 'abo';
    }

    function kbZeigen(o) {
      if (!kb || !o) { return; }
      var modus = kbModus(o);
      wurzel.setAttribute('data-modus', modus);
      [].slice.call(wurzel.querySelectorAll('.fenou-kb__segbtn')).forEach(function (s) {
        s.setAttribute('aria-pressed', s.getAttribute('data-modus') === modus ? 'true' : 'false');
      });
      var kopf = wurzel.querySelector('.fenou-kb__info-kopf');
      if (kopf) { kopf.textContent = o.getAttribute('data-info') || ''; }
      var dfz = wurzel.querySelector('.fenou-kb__dfz');
      if (dfz) { dfz.hidden = o.getAttribute('data-dfz') !== '1'; }
      var nudge = wurzel.querySelector('.fenou-kb__nudge-txt');
      if (nudge && o.hasAttribute('data-nudge')) { nudge.textContent = o.getAttribute('data-nudge'); }
    }

    if (kb) {
      [].slice.call(wurzel.querySelectorAll('.fenou-kb__segbtn, .fenou-kb__zumabo')).forEach(function (s) {
        s.addEventListener('click', function () {
          var modus = s.getAttribute('data-modus');
          if (kbModus(gewaehlt) === modus) { return; }
          var gruppe = wurzel.querySelector('.fenou-kb__tiles[data-gruppe="' + modus + '"]');
          if (!gruppe) { return; }
          var menge = gewaehlt ? gewaehlt.getAttribute('data-menge') : '';
          var ziel = gruppe.querySelector('.fenou-abo__opt[data-menge="' + menge + '"]') ||
                     gruppe.querySelector('.fenou-abo__opt');
          if (ziel) { waehlen(ziel); }
        });
      });
      /* Formular, Kaufknopf und Infozeile sofort auf die vorgewaehlte
         Kachel setzen -- im Sale ist das der Einmalkauf, und ein vom
         Theme vorbelegtes selling_plan darf dann nicht stehen bleiben.
         Nach dem aktuellen Durchlauf, damit die Initialisierung des
         Themes ihren Stand nicht darueber schreibt. */
      if (gewaehlt) { setTimeout(function () { waehlen(gewaehlt); }, 0); }
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () { waehlen(o); });
    });

    /* Auch ohne Klick: Die groesste Stufe ist vorgewaehlt, also soll
       der Betrag von Anfang an im Knopf stehen. */
    if (gewaehlt) { knopfBeschriften(gewaehlt); }

    /* ----------------------------------------------------------
       Mengenwahl im Einmalkauf. Sie sitzt innerhalb der Option,
       also muss der Klick dort aufhoeren -- sonst waehlt er
       zusaetzlich die Zeile neu und setzt die Menge zurueck.
       ---------------------------------------------------------- */
    var qbs = [].slice.call(wurzel.querySelectorAll('.fenou-abo__qb'));
    var einmal = wurzel.querySelector('.fenou-abo__opt[data-k="once"]');
    var einmalPr = wurzel.querySelector('.fenou-abo__once-pr');
    var einmalStreich = wurzel.querySelector('.fenou-abo__once-streich');
    var tage = parseInt(wurzel.getAttribute('data-tage'), 10) || 30;

    qbs.forEach(function (b) {
      function nimm(e) {
        e.stopPropagation();
        qbs.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        if (einmal) {
          var preis = parseInt(b.getAttribute('data-preis'), 10) || 0;
          var menge = parseInt(b.getAttribute('data-menge'), 10) || 1;
          var streich = parseInt(b.getAttribute('data-streich'), 10) || 0;
          einmal.setAttribute('data-variant', b.getAttribute('data-variant'));
          einmal.setAttribute('data-preis', String(preis));
          if (einmalPr) { einmalPr.textContent = euro(preis); }

          /* Streichpreis nur zeigen, wenn wirklich etwas gespart
             wird. Bei 1x gibt es keinen -- dann bleibt die Zeile
             leer statt "39,99 statt 39,99" zu behaupten. */
          if (einmalStreich) {
            if (streich > preis) {
              einmalStreich.textContent = euro(streich);
              einmalStreich.hidden = false;
            } else {
              einmalStreich.hidden = true;
            }
          }

          var tagEl = einmal.querySelector('.fenou-abo__day');
          if (tagEl) { tagEl.textContent = euro(Math.round(preis / (tage * menge))) + ' / Tag'; }
          waehlen(einmal);
        }
      }
      b.addEventListener('click', nimm);
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); nimm(e); }
      });
    });

    /* ----------------------------------------------------------
       Sicherheitsnetz: kurz vor dem Absenden noch einmal setzen.
       Die Variantenwahl des Themes laeuft weiter (sie ist nur
       ausgeblendet) und koennte name="id" zwischendurch
       ueberschrieben haben. capture, damit dies vor dem
       Absende-Handler des Themes laeuft.
       ---------------------------------------------------------- */
    form.addEventListener('submit', uebernehmen, true);

    /* ----------------------------------------------------------
       Sticky-Leiste
       ---------------------------------------------------------- */
    var menu = null;

    /* Das Menue zeigt dieselben Optionen noch einmal. Damit nicht
       zwei Markierungen auseinanderlaufen koennen, wird die des
       Menues bei jeder Anzeige neu aus der Liste abgeleitet -- die
       Liste ist die Wahrheit, das Menue ihr Abbild. */
    function spiegeln() {
      if (!menu) { return; }
      [].slice.call(menu.querySelectorAll('.fenou-abobar__mi')).forEach(function (mi, i) {
        mi.classList.toggle('is-on', opts[i] === gewaehlt);
      });
    }

    if (bar) {
      /* Die Leiste wandert an den Body.

         Grund: position: fixed haengt nicht immer am Fenster. Hat
         irgendein Vorfahr transform, filter, perspective, contain
         oder will-change, wird er selbst zum Bezugsrahmen -- die
         Leiste verhaelt sich dann wie absolute und sitzt irgendwo
         im Formular statt unten am Bildschirm. Genau so sieht es
         aus, als waere sie "nicht da".

         Am Desktop trat das nicht auf, aber solche Eigenschaften
         kommen haeufig aus Medienabfragen fuer kleine Schirme --
         Slider, Einblend-Animationen. Statt jeden Vorfahren zu
         pruefen, wird der Fall ausgeschlossen: direkt am Body kann
         kein Element dazwischenliegen. */
      document.body.appendChild(bar);
      bar.hidden = false;

      /* Das Aufklappmenue wird aus den vorhandenen Optionen gebaut,
         nicht doppelt gepflegt: Kommt eine Abo-Stufe dazu, steht sie
         ohne Zutun auch hier. Sichtbar ist der Ausloeser nur auf dem
         Desktop -- das regelt das CSS, nicht dieses Skript. */
      var pick = bar.querySelector('.fenou-abobar__pick');
      if (pick) {
        menu = document.createElement('div');
        menu.className = 'fenou-abobar__menu';
        menu.hidden = true;

        opts.forEach(function (o) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'fenou-abobar__mi';

          var oNm = o.querySelector('.fenou-abo__nm');
          var oMeta = o.querySelector('.fenou-abo__meta');

          /* Aus echten Textknoten zusammengesetzt, nicht per
             innerHTML. Die Texte stammen zwar aus diesem Baustein,
             aber sie tragen Werte aus dem Shop -- und was einmal
             ueber innerHTML laeuft, laeuft auch dann darueber, wenn
             dort eines Tages spitze Klammern stehen. */
          var links = document.createElement('span');
          links.appendChild(document.createTextNode(oNm ? oNm.childNodes[0].nodeValue.trim() : ''));
          var klein = document.createElement('small');
          klein.textContent = oMeta ? oMeta.textContent : '';
          links.appendChild(klein);

          var rechts = document.createElement('span');
          rechts.textContent = euro(parseInt(o.getAttribute('data-preis'), 10) || 0);

          b.appendChild(links);
          b.appendChild(rechts);
          b.addEventListener('click', function () {
            waehlen(o);
            menu.hidden = true;
            pick.setAttribute('aria-expanded', 'false');
          });
          menu.appendChild(b);
        });

        bar.appendChild(menu);

        pick.addEventListener('click', function () {
          var auf = menu.hidden;
          menu.hidden = !auf;
          pick.setAttribute('aria-expanded', auf ? 'true' : 'false');
        });

        document.addEventListener('click', function (e) {
          if (!menu.hidden && !bar.contains(e.target)) {
            menu.hidden = true;
            pick.setAttribute('aria-expanded', 'false');
          }
        });
      }

      /* Hinauf zur Auswahl.

         Warum nicht scrollIntoView: Die Kopfzeile klebt oben und
         wuerde die erste Zeile verdecken. Ihre Hoehe wird gemessen
         statt geraten -- ein umgebautes Menue schneidet sonst
         stillschweigend die oberste Option ab. */
      function hinauf() {
        var ziel = wurzel.querySelector('.fenou-abo__opts');
        if (!ziel) { return; }
        var kopf = document.querySelector('store-header[sticky], .header');
        var luft = (kopf ? kopf.offsetHeight : 0) + 12;
        var y = Math.max(0, ziel.getBoundingClientRect().top + window.scrollY - luft);
        var sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var start = window.scrollY;

        window.scrollTo({ top: y, behavior: sanft ? 'smooth' : 'auto' });

        /* Absicherung, und zwar aus Messung, nicht aus Vorsicht:
           Auf dieser Seite laeuft ein weiches Scrollen nicht immer
           an. Gemessen am 22.09.2026 -- window.scrollTo mit
           behavior 'auto' bewegt die Seite, mit 'smooth' bleibt sie
           stehen, sobald der Aufruf nicht unmittelbar im Klick
           haengt, sondern nach den beiden Warenkorb-Anfragen kommt.

           Statt deshalb generell hart zu springen -- weich ist die
           ruhigere Bewegung, wo sie laeuft -- wird nachgesehen: Hat
           sich nach 500ms ueberhaupt nichts geruehrt, ist die
           Animation nicht angelaufen und die Seite wird gesetzt.
           Ein laufendes Scrollen bricht das nicht ab, denn dann ist
           die Bedingung nicht erfuellt. */
        if (sanft) {
          setTimeout(function () {
            if (Math.abs(window.scrollY - start) < 4) { window.scrollTo(0, y); }
          }, 500);
        }
      }

      /* In den Warenkorb legen, ohne die Schublade zu oeffnen.

         Das Theme kennt dafuer schon einen Weg: Es meldet einen
         neuen Warenkorb mit dem Ereignis cart:refresh, und dessen
         Detailfeld openMiniCart entscheidet, ob die Schublade
         aufgeht (theme.js: "if (event?.detail?.openMiniCart)").
         Mit false wird also alles aktualisiert -- Zahl am Symbol,
         Inhalt der Schublade -- aber nichts geoeffnet.

         Die Beschriftungen sind dieselben wie am grossen Kaufknopf
         in fenou-main-product.js. Zwei verschiedene Formulierungen
         fuer denselben Vorgang auf einer Seite waeren schlechter
         als eine. */
      var cta = bar.querySelector('.fenou-abobar__cta');
      if (cta) {
        var ctaText = cta.textContent;

        cta.addEventListener('click', function () {
          if (cta.disabled) { return; }

          /* Auch das Formular mitziehen: Wer danach oben den
             grossen Knopf drueckt, soll dieselbe Stufe kaufen. */
          uebernehmen();

          var posten = { id: parseInt(gewaehlt.getAttribute('data-variant'), 10), quantity: 1 };
          var plan = gewaehlt.getAttribute('data-plan');
          if (plan) { posten.selling_plan = parseInt(plan, 10); }

          cta.disabled = true;
          cta.textContent = 'Wird hinzugefügt...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [posten] })
          }).then(function (r) {
            if (!r.ok) { throw new Error('add'); }
            return fetch('/cart.js');
          }).then(function (r) {
            return r.json();
          }).then(function (cart) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cart, openMiniCart: false }
            }));
            cta.textContent = 'Hinzugefügt ✓';
            hinauf();
            setTimeout(function () {
              cta.textContent = ctaText;
              cta.disabled = false;
            }, 1800);
          }).catch(function () {
            /* Nicht hinaufscrollen, wenn nichts im Warenkorb
               gelandet ist -- der Ortswechsel wuerde wie ein Erfolg
               aussehen. */
            cta.textContent = 'Fehler – erneut versuchen';
            setTimeout(function () {
              cta.textContent = ctaText;
              cta.disabled = false;
            }, 2200);
          });
        });
      }

      /* Verstecken beim Runterscrollen -- nur dort, wo die Leiste
         die volle Breite einnimmt. Auf dem Desktop steht sie in
         der Ecke und stoert nicht, also bleibt sie.
         Dieselben Regeln wie der Header in nav-v2.js: Schwelle
         30px, und nie wegziehen, solange eine Schublade offen ist
         oder jemand darin per Tastatur unterwegs ist. */
      /* Solange die Kaufauswahl im Bild steht, bleibt die Leiste
         unten -- sie zeigte sonst dasselbe ein zweites Mal, zwei
         Handbreit voneinander entfernt. Erst wenn die Auswahl nach
         oben aus dem Bild gescrollt ist, faehrt sie ein.

         Die Klasse wird in jeder Breite gesetzt, und seit dem
         23.09.2026 wertet sie auch das Handy aus -- vorher stand
         dort keine Regel dafuer.

         Von Anfang an gesetzt, nicht erst beim ersten Rueckruf:
         Sonst blitzte die Leiste beim Laden kurz auf, bevor sie
         wieder verschwindet.

         Fehlt IntersectionObserver, wird die Klasse gar nicht erst
         gesetzt -- dann bleibt die Leiste durchgehend erreichbar,
         so wie vorher. Das ist die richtige Richtung zum Ausfallen:
         lieber eine Leiste zu viel als eine, die nie erscheint. */
      var optionen = wurzel.querySelector('.fenou-abo__opts');
      if (optionen && 'IntersectionObserver' in window) {
        bar.classList.add('is-bei-optionen');
        new IntersectionObserver(function (eintraege) {
          bar.classList.toggle('is-bei-optionen', eintraege[0].isIntersecting);
        }).observe(optionen);
      }

      var letztesY = window.scrollY;
      var summe = 0;
      var weg = false;
      var laeuft = false;

      function gesperrt() {
        if (document.documentElement.classList.contains('lock-all')) { return true; }
        if (menu && !menu.hidden) { return true; }
        if (document.activeElement && bar.contains(document.activeElement)) { return true; }
        return false;
      }

      /* Gilt in jeder Breite. Frueher sprang diese Pruefung auf
         dem Desktop sofort zurueck und holte die Leiste immer
         wieder hervor -- dort stand sie fest in der Ecke. Seit sie
         unten mittig sitzt, soll sie sich wie auf dem Handy
         verhalten: beim Runterscrollen weg, beim Hochscrollen da. */
      function pruefen() {
        laeuft = false;
        var y = window.scrollY;
        var d = y - letztesY;
        letztesY = y;
        if (gesperrt()) { return; }
        if (y < 80) {
          if (weg) { bar.classList.remove(VERSTECKT); weg = false; }
          summe = 0;
          return;
        }
        if ((d > 0) !== (summe > 0)) { summe = 0; }
        summe += d;
        if (summe > SCHWELLE && !weg) { bar.classList.add(VERSTECKT); weg = true; summe = 0; }
        else if (summe < -SCHWELLE && weg) { bar.classList.remove(VERSTECKT); weg = false; summe = 0; }
      }

      /* Beim Runterscrollen verschwindet sie -- so gewollt. Sobald
         die Bewegung aber aufhoert, kommt sie zurueck.

         Ohne das waere sie genau dann weg, wenn jemand nach unten
         gescrollt hat und nun liest oder ueberlegt: also in dem
         Moment, in dem man kaufen will. Beim Header ist Verstecken
         richtig, weil man ihn beim Lesen nicht braucht; bei einer
         Kaufleiste ist es das Gegenteil.

         600ms, damit sie nicht zwischen zwei Wischern aufblitzt. */
      var ruhe = null;

      window.addEventListener('scroll', function () {
        if (!laeuft) { laeuft = true; window.requestAnimationFrame(pruefen); }
        if (ruhe) { clearTimeout(ruhe); }
        ruhe = setTimeout(function () {
          if (weg && !gesperrt()) {
            bar.classList.remove(VERSTECKT);
            weg = false;
            summe = 0;
          }
        }, 600);
      }, { passive: true });

    }

    uebernehmen();
    anzeigen();

    /* Noch einmal kurz nach dem Laden.

       Die eigene Produktseite von OVA GOLD setzt den Preis in ihrem
       Kaufknopf aus ihrer alten Auswahl heraus -- und zwar nachdem
       dieses Skript schon gelaufen ist. Ohne die Wiederholung bliebe
       dort der Preis der zufaellig vorausgewaehlten Variante stehen
       (gemessen: 89,98 € statt 49,99 €), waehrend oben "1 Zyklus"
       markiert ist.

       400ms statt 0: Das fremde Skript laeuft nicht synchron, ein
       einzelner Tick reicht nicht zuverlaessig. */
    setTimeout(anzeigen, 400);
  }

  function start() {
    [].slice.call(document.querySelectorAll('fenou-abo')).forEach(init);
  }

  /* Der Quick Cart laedt seinen Inhalt per AJAX nach, also lange nach
     DOMContentLoaded. Die Auswahl war dort zwar sichtbar, aber tot:
     Ohne Klick-Behandlung liess sich keine Option anwaehlen -- gemeldet
     am 30.09.2026.

     Ein MutationObserver faengt das ab. Er ist einem Custom Element
     vorgezogen, weil der Baustein kein Shadow DOM braucht und die
     bestehende init-Funktion unveraendert bleiben kann; ein Umbau auf
     customElements haette jede Zeile darin angefasst.

     Beobachtet wird nur das Hinzufuegen von Knoten, nicht jedes
     Attribut -- sonst liefe der Beobachter bei jeder Preisaenderung
     mit. */
  function beobachten() {
    if (!window.MutationObserver) { return; }
    new MutationObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        var neue = eintraege[i].addedNodes;
        for (var j = 0; j < neue.length; j++) {
          var k = neue[j];
          if (k.nodeType !== 1) { continue; }
          if (k.tagName === 'FENOU-ABO') { init(k); }
          else if (k.querySelectorAll) {
            [].slice.call(k.querySelectorAll('fenou-abo')).forEach(init);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); beobachten(); });
  } else {
    start();
    beobachten();
  }
})();
